import React from 'react';
import { useNavigate } from 'react-router-dom';

const WhyEmit = () => {
  const navigate = useNavigate();

  return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #1a1a2e 0%, #16213e 100%)',
      color: 'white',
      padding: '80px 5%'
    }}>
      {/* Header */}
      <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
        <h1 style={{
          fontSize: 'clamp(36px, 6vw, 56px)',
          fontWeight: '800',
          textAlign: 'center',
          marginBottom: '24px',
          color: '#4A90E2'
        }}>
          Why Emit?
        </h1>
        
        <p style={{
          fontSize: 'clamp(18px, 3vw, 24px)',
          textAlign: 'center',
          maxWidth: '800px',
          margin: '0 auto 60px',
          color: 'rgba(255,255,255,0.8)'
        }}>
          Most Bible apps help you <strong>talk about</strong> the Bible.<br/>
          Emit helps you <strong>BECOME</strong> the Bible.
        </p>

        {/* Key Differentiator */}
        <div style={{
          background: 'rgba(74, 144, 226, 0.1)',
          border: '2px solid #4A90E2',
          borderRadius: '20px',
          padding: '40px',
          marginBottom: '60px',
          textAlign: 'center'
        }}>
          <h2 style={{ fontSize: '28px', marginBottom: '20px', color: '#4A90E2' }}>
            The First Operating System for Human Transformation
          </h2>
          <p style={{ fontSize: '18px', lineHeight: '1.8', color: 'rgba(255,255,255,0.9)' }}>
            Emit isn't just another Bible chat app. It's a complete <strong>transformation platform</strong> that 
            tracks your spiritual growth, guides your daily practice, and helps you embody scripture—not just study it.
          </p>
        </div>

        {/* Comparison Grid */}
        <h2 style={{ fontSize: '32px', marginBottom: '40px', textAlign: 'center' }}>
          What Makes Emit Different?
        </h2>

        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
          gap: '24px',
          marginBottom: '60px'
        }}>
          {[
            {
              icon: '🎯',
              title: 'Measurable Transformation',
              description: 'Track your spiritual growth with 12 consciousness levels, MindStream progress, and practice analytics.',
              unique: 'Other apps: Just Q&A with no tracking'
            },
            {
              icon: '📊',
              title: 'Complete Practice System',
              description: 'Log daily practices, build streaks, and see visual progress across Power, Flow, and Clarity MindStreams.',
              unique: 'Other apps: No practice logging'
            },
            {
              icon: '🚀',
              title: 'Structured Journey',
              description: 'Progress through 4 journey stages: Installation → Operation → Maintenance → Upgrade.',
              unique: 'Other apps: No structured path'
            },
            {
              icon: '🧠',
              title: 'FHO Framework',
              description: 'Unique transformation methodology: Freedom (with God), Happiness (with Self), Oneness (with Others).',
              unique: 'Other apps: Generic guidance'
            },
            {
              icon: '🎮',
              title: 'Gamified Growth',
              description: 'Earn consciousness points, unlock levels, collect badges, and watch your transformation quantified.',
              unique: 'Other apps: No gamification'
            },
            {
              icon: '📈',
              title: 'Analytics Dashboard',
              description: 'Visual charts showing time distribution, practice balance, streak history, and consciousness growth.',
              unique: 'Other apps: No analytics'
            }
          ].map((feature, idx) => (
            <div key={idx} style={{
              background: 'rgba(255, 255, 255, 0.05)',
              padding: '32px',
              borderRadius: '16px',
              border: '1px solid rgba(74, 144, 226, 0.3)',
              transition: 'all 0.3s ease',
              cursor: 'pointer'
            }}
            onMouseEnter={e => {
              e.currentTarget.style.transform = 'translateY(-8px)';
              e.currentTarget.style.borderColor = '#4A90E2';
            }}
            onMouseLeave={e => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.borderColor = 'rgba(74, 144, 226, 0.3)';
            }}>
              <div style={{ fontSize: '48px', marginBottom: '16px' }}>{feature.icon}</div>
              <h3 style={{ fontSize: '22px', marginBottom: '12px', color: '#4A90E2' }}>
                {feature.title}
              </h3>
              <p style={{ fontSize: '16px', lineHeight: '1.6', marginBottom: '16px', color: 'rgba(255,255,255,0.8)' }}>
                {feature.description}
              </p>
              <div style={{
                fontSize: '14px',
                color: '#50C878',
                fontWeight: '600',
                padding: '8px',
                background: 'rgba(80, 200, 120, 0.1)',
                borderRadius: '8px'
              }}>
                ✨ {feature.unique}
              </div>
            </div>
          ))}
        </div>

        {/* Matthew 13:52 Quote */}
        <div style={{
          background: 'linear-gradient(135deg, rgba(153, 102, 204, 0.2), rgba(74, 144, 226, 0.2))',
          border: '2px solid #9966CC',
          borderRadius: '20px',
          padding: '40px',
          marginBottom: '60px',
          textAlign: 'center'
        }}>
          <div style={{ fontSize: '40px', marginBottom: '16px' }}>📖</div>
          <p style={{
            fontSize: '20px',
            fontStyle: 'italic',
            marginBottom: '16px',
            lineHeight: '1.8',
            color: 'white'
          }}>
            "Therefore every scribe who has been trained for the kingdom of heaven is like a master 
            of a house, who brings out of his treasure what is new and what is old."
          </p>
          <p style={{ fontSize: '16px', color: '#9966CC', fontWeight: '600' }}>
            — Matthew 13:52
          </p>
        </div>

        {/* The Transformation Journey */}
        <div style={{ marginBottom: '60px' }}>
          <h2 style={{ fontSize: '32px', marginBottom: '40px', textAlign: 'center' }}>
            Your Transformation Journey
          </h2>
          
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
            gap: '20px'
          }}>
            {[
              { stage: 'Installation', desc: 'Begin your journey, learn the framework', color: '#E8E8E8' },
              { stage: 'Operation', desc: 'Practice daily, build habits, see growth', color: '#FFD700' },
              { stage: 'Maintenance', desc: 'Sustain transformation, deepen practice', color: '#50C878' },
              { stage: 'Upgrade', desc: 'Mastery, teaching others, divine stasis', color: '#9966CC' }
            ].map((stage, idx) => (
              <div key={idx} style={{
                background: 'rgba(255, 255, 255, 0.05)',
                padding: '24px',
                borderRadius: '12px',
                borderLeft: `4px solid ${stage.color}`,
                textAlign: 'center'
              }}>
                <h3 style={{ fontSize: '24px', color: stage.color, marginBottom: '12px' }}>
                  {idx + 1}. {stage.stage}
                </h3>
                <p style={{ fontSize: '15px', color: 'rgba(255,255,255,0.7)' }}>
                  {stage.desc}
                </p>
              </div>
            ))}
          </div>
        </div>

        {/* CTA Section */}
        <div style={{
          background: 'linear-gradient(135deg, #4A90E2, #50C878)',
          borderRadius: '20px',
          padding: '60px 40px',
          textAlign: 'center'
        }}>
          <h2 style={{ fontSize: '36px', marginBottom: '20px', color: 'white' }}>
            Ready to Transform?
          </h2>
          <p style={{ fontSize: '20px', marginBottom: '40px', color: 'rgba(255,255,255,0.9)' }}>
            Don't just read the Bible. Become it.
          </p>
          <div style={{ display: 'flex', gap: '20px', justifyContent: 'center', flexWrap: 'wrap' }}>
            <button
              onClick={() => {
                const token = localStorage.getItem('token');
                navigate(token ? '/emit-the-bible' : '/register');
                window.scrollTo(0, 0);
              }}
              style={{
                padding: '20px 40px',
                fontSize: '20px',
                fontWeight: '700',
                background: 'white',
                color: '#4A90E2',
                border: 'none',
                borderRadius: '30px',
                cursor: 'pointer',
                boxShadow: '0 4px 20px rgba(0,0,0,0.2)'
              }}
            >
              Start Free Trial
            </button>
            <button
              onClick={() => {
                navigate('/platform');
                window.scrollTo(0, 0);
              }}
              style={{
                padding: '20px 40px',
                fontSize: '20px',
                fontWeight: '700',
                background: 'transparent',
                color: 'white',
                border: '2px solid white',
                borderRadius: '30px',
                cursor: 'pointer'
              }}
            >
              Learn More
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WhyEmit;
